<template>
    <div class="Customerservice">
        <div class="consult_contact" @click="Customerservice()">
            <div class="consult_wrap">
                <a rel="nofollow" target="_blank">
                    <div class="box ball">
                        <img src="../../assets/image/ball.png"  alt="">
                    </div>
                    <div class="box staff_img">
                        <div class="picbox" id="picbox">
                            <div class="boxs front">
                                <img src="../../assets/image/bg_00.png" alt="">
                            </div>
                            <div class="boxs back">
                                 <p>联系老师</p>
                            </div>                            
                        </div>
                    </div>                    
                    <div class="box bg-1">
                        <img src="../../assets/image/bg_1.png"  alt="">
                    </div>                      
                    
                    <!-- <img src="../../assets/image/bg_2.png" class="bg-2" alt="">
                    <img src="../../assets/image/bg_3.png" class="bg-3" alt=""> -->
                </a>
            </div> 
        </div> 
    </div>
    
</template>
<script>
export default {
    data() {
        return {
           timer:'', 
        }
    },
    methods: {
        Customerservice(){
            window.location.href = "https://work.weixin.qq.com/kfid/kfce89da5aef2a89573?enc_scene=ENCBoSNJ9a7HszPWeBNnEBmStzCNbn2X2Vpjma3xzx3F8rv"
                                    
        },
        
        kefu(){
            let _this = this
            let scrollTip = document.querySelector("#picbox");
            clearInterval(_this.timer); 
            if(scrollTip){
                scrollTip.classList.add('picboxa');
                //监听动画是否结束
                scrollTip.addEventListener('animationend',function(){
                //     //动画结束，移除动画的样式类
                    scrollTip.classList.remove('picboxa');
                    // scrollTip.classList.add('picboxb');
                //     //延时1秒，再将动画加入
                })
                _this.timer = setInterval(()=>{  // 自动轮播
                        _this.kefu()
                }, 10000)
            }
        }
    },
    mounted() {
        this.kefu()
    },

    
}
</script>
<style lang="scss" scoped>
    .Customerservice{
        .service{
            width: 1.1rem;
            height: 1.1rem;
            background: chocolate;
            border-radius: 50%;
            position: fixed;
            bottom: 2.5rem;
            right: 0;
        }
        .box.staff_img {
            /* 自定义宽高，可根据需求调整 */
            width: .9rem;
            height: .9rem;
            /*margin: 50px auto;  居中显示 */
            /* 3D 透视：数值越大，透视效果越弱（建议 1000px） */
            -webkit-perspective: 1000px;
            perspective: 1000px;
        }
 
        .boxs.front img {
            width: 100%;
            height: 100%;
            object-fit: cover; /* 保持图片比例，覆盖容器 */
        }
        .consult_wrap .staff_img .text{
            position: absolute;
            width: 100%; 
            height: 100%;
            color: white;
            text-align: center;
            transform: rotateY(180deg);
            backface-visibility: hidden;            
        }
        .consult_wrap .box img{
            width: 100%; 
            height: 100%;
        }
        .consult_contact{position:fixed;bottom:15%;right:0;width:1.2rem;height:1.2rem;cursor:pointer;}
        .consult_wrap{position:relative;width:1.2rem;height:1.2rem;}
        .consult_contact .box{position:absolute;left:50%;top:50%;-webkit-transform:translate3d(-50%, -50%, 0);transform:translate3d(-50%, -50%, 0);}
        .consult_contact .ball img{
            width: .15rem;
            height: .15rem;
            display: block;
            margin-top: 50%;
            transform: translateY(-50%);           
        }
        @keyframes ballRotatea{
            0%{transform:rotateY(0deg);}
            50%{transform:rotateY(180deg);}
            50%{transform:rotateY(-180deg);}
            100%{transform:rotateY(0);}
      
        }
        @keyframes ballRotateb{
            0%{transform:rotateY(180deg);}
            100%{transform:rotateY(0deg);}
           
        }
        @keyframes ballRotatec{
            0%{transform:rotateY(180deg);}
            100%{transform:rotateY(0deg);}
           
        }
        @keyframes ballRotate{
            0%{transform:rotate(0);}
            100%{transform:rotate(360deg);}
            
        }
        .consult_contact .ball{
            top: 50%;
            width: 1.05rem;
            height: 1.05rem;
            transform-origin: 0 0; 
            animation:ballRotate 2.5s infinite linear;
            z-index:9999;
        }
        @keyframes bg2Animation{0%{opacity:0;}
            50%{opacity:1;}
            100%{opacity:0;}
        }
        .consult_contact .bg-1{width: 1.2rem; height: 1.2rem;}
        .consult_contact .bg-2{animation:bg2Animation 2.5s infinite linear;}
        .consult_contact:hover .tip{display:block;}        
    }
        .picbox {
            position: relative; /* 作为子元素绝对定位的参考 */
            width: 100%;
            height: 100%;
            /* 保留子元素的 3D 变换效果（关键，兼容 iOS） */
            -webkit-transform-style: preserve-3d;
            transform-style: preserve-3d;
            /* 翻转过渡动画，让效果更丝滑 */
            -webkit-transition: -webkit-transform 0.6s ease;
            transition: transform 0.6s ease;
            /* 触发 iOS GPU 硬件加速，解决渲染卡顿/闪烁 */
            -webkit-transform: translateZ(0);
            transform: translateZ(0);
        }
        .picboxa{
            animation:ballRotatea 5s ;
        }
        .picboxb{
            animation:ballRotateb 5s ;
        }
        .boxs {
            position: absolute; /* 叠加显示 */
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            /* 隐藏背面（关键，兼容 iOS） */
            -webkit-backface-visibility: hidden;
            backface-visibility: hidden;
            /* 触发硬件加速，配合非透明背景避免背面失效 */
            -webkit-transform: translateZ(0);
            transform: translateZ(0);
            /* 内容居中（图片/文字） */
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: 50%;
            overflow: hidden;
            -webkit-font-smoothing: antialiased; /* 禁止文字抗锯齿闪烁 */
        }

        .boxs.front {
            background-color: #fff; /* 非透明背景，兼容 iOS 背面隐藏 */
        }
        .boxs p{
            height: 100%;
            color: #fff;
            font-size: .26rem;
            text-align: center;
            width: 80%;
            margin: 0 auto;
            padding-top: 10%;
        }
        .back{
            -webkit-transform: rotateY(180deg);
            -ms-transform: rotateY(180deg);
            -o-transform: rotateY(180deg);
            transform: rotateY(180deg);
            background: #3464ff;
            border-radius:50%;
            overflow: hidden;
        }
        .back h2{
            color: white;
            text-align: center;
        }

</style>